import React from 'react';
import SafeIcon from '../../SafeIcon';
import { FiSend } from 'react-icons/fi';

const ContactFormWidget = ({ styles = {}, onSubmitPreview }) => {
  const {
    buttonText = 'Send Message',
    buttonBgColor = '#2dd4bf',
    buttonTextColor = '#ffffff',
    borderRadius = 12,
    destinationEmail = '',
    formBgColor = '#ffffff',
    inputBgColor = '#f9fafb',
    textColor = '#111827'
  } = styles;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmitPreview) {
      // In the builder, just trigger the settings popup instead of submitting
      onSubmitPreview();
      return;
    }
    
    if (destinationEmail) {
      // In a real production app, this would hit an API endpoint.
      // For a static site, opening the user's mail client is a safe fallback.
      window.location.href = `mailto:${destinationEmail}`;
    } else {
      alert('This form needs a destination email configured in the settings.');
    }
  };

  return (
    <div className="w-full max-w-xl mx-auto p-8 shadow-sm border border-gray-100" style={{ backgroundColor: formBgColor, borderRadius: `${borderRadius}px` }}>
      <form onSubmit={handleSubmit} className="space-y-5">
        <div className="grid grid-cols-2 gap-5">
          <div className="col-span-2 sm:col-span-1">
            <label className="block text-[10px] font-black uppercase tracking-widest mb-2" style={{ color: textColor }}>First Name</label>
            <input 
              type="text" 
              required 
              className="w-full p-3.5 outline-none focus:ring-2 focus:ring-teal-400/30 transition-all text-sm font-medium border border-gray-200" 
              style={{ backgroundColor: inputBgColor, borderRadius: `${Math.max(0, borderRadius - 4)}px`, color: textColor }} 
              placeholder="John" 
            />
          </div>
          <div className="col-span-2 sm:col-span-1">
            <label className="block text-[10px] font-black uppercase tracking-widest mb-2" style={{ color: textColor }}>Last Name</label>
            <input 
              type="text" 
              required 
              className="w-full p-3.5 outline-none focus:ring-2 focus:ring-teal-400/30 transition-all text-sm font-medium border border-gray-200" 
              style={{ backgroundColor: inputBgColor, borderRadius: `${Math.max(0, borderRadius - 4)}px`, color: textColor }} 
              placeholder="Doe" 
            />
          </div>
        </div>
        
        <div>
          <label className="block text-[10px] font-black uppercase tracking-widest mb-2" style={{ color: textColor }}>Email Address</label>
          <input 
            type="email" 
            required 
            className="w-full p-3.5 outline-none focus:ring-2 focus:ring-teal-400/30 transition-all text-sm font-medium border border-gray-200" 
            style={{ backgroundColor: inputBgColor, borderRadius: `${Math.max(0, borderRadius - 4)}px`, color: textColor }} 
            placeholder="john@example.com" 
          />
        </div>
        
        <div>
          <label className="block text-[10px] font-black uppercase tracking-widest mb-2" style={{ color: textColor }}>Message</label>
          <textarea 
            required 
            rows="4" 
            className="w-full p-3.5 outline-none focus:ring-2 focus:ring-teal-400/30 transition-all text-sm font-medium resize-none border border-gray-200" 
            style={{ backgroundColor: inputBgColor, borderRadius: `${Math.max(0, borderRadius - 4)}px`, color: textColor }} 
            placeholder="How can we help you?" 
          />
        </div>
        
        <button 
          type="submit" 
          className="w-full p-4 font-black transition-transform hover:scale-[1.02] flex items-center justify-center space-x-2 shadow-lg" 
          style={{ backgroundColor: buttonBgColor, color: buttonTextColor, borderRadius: `${Math.max(0, borderRadius - 2)}px` }}
        >
          <span>{buttonText}</span>
          <SafeIcon icon={FiSend} className="w-4 h-4 ml-1" />
        </button>
      </form>
    </div>
  );
};

export default ContactFormWidget;